import Groups from "./Groups"

export default  Groups;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/Groups/index.js